import { CategorizationOfSoftwareSolutionsIcon } from '@/svgs'
import React from 'react'

function AppSolutions() {
   return (
      <section className="industries-bg-image">
         <div className="container">
            <h2 className="text-center cs-text-secondary tech_title section_heading_title mb-2">
               Boost Your Real Estate Business with Our Custom App Solutions
            </h2>
            <p className="section_desc cs-text-secondary mb-0">
               Being a small firm or a global corporation, Benzatine supply chain and logistics software solutions fit your specific business requirements. With our company being a valued technology partner in the logistics sector, we enable you to remain nimble, effective, and competitive in today's fast-changing environment.
            </p>

            <div className="mt-5 d-flex text-center">
               <CategorizationOfSoftwareSolutionsIcon />
            </div>
         </div>
      </section>
   )
}

export default AppSolutions
